export class FolderDraftEmailsChangeEvent {
    constructor(
        public folderId: string,
        public hasDraft: boolean
    ) {}
}
